<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
				<FormItem label="标题" prop="title" class="sj">
					<Input v-model="formValidate.title" placeholder="请输入标题"></Input>
				</FormItem>
				<FormItem label="所属人" prop="their" class="sj">
					<Select v-model="formValidate.their" placeholder="所属人"  @on-change="onchange">
						<Option value="小捷智购">小捷智购</Option>
					</Select>
				</FormItem>
				<Row class=''>
					<Col span="8">
					<FormItem label="上传图片" class="">
						<!-- <Img @imgFile='imgFile' :size="1"/> -->
						<Imgs @imgFile='imgFile' number='3' :url="url"/>
						
					</FormItem>
					</Col>
				</Row>
				
				<FormItem label="是否发布" prop="release" class="sj">
					<Select v-model="formValidate.release" placeholder="请选择是否必须更新">
						<Option value="shi">发布</Option>
						<Option value="fou">待发布</Option>
					</Select>
				</FormItem>
				<FormItem label="内容" prop="value" class="sj">
					<Input v-model="formValidate.value" placeholder="请输入值"  show-word-limit type="textarea"></Input>
				</FormItem>
				
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	import Region from '@/components/comm/region.vue'
	import Imgs from '@/components/comm/imgs.vue'
	export default {
		data() {
			return {
				url:'',
				formValidate: {
					title: '',
					their: '小捷智购',
					value:'',
					urls:'',
					release:'shi'
				},
				ruleValidate: {
					title: [{
						required: true,
						message: '标题不能为空！！！',
						trigger: 'blur'
					}],
					their: [{
						required: true,
						message: '所属人不能为空！！！',
						trigger: 'blur'
					}],
					value: [{
						required: true,
						message: '内容不能为空！！！',
						trigger: 'blur'
					}],
					release: [{
						required: true,
						message: '是否发布！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		created() {
			
			let _this=this
			_this.url=http.url+"/file/img/xinwen"
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			//接收img子组件返回的方法
			imgFile(files) {
				//this.formValidate.img=files
				console.log(files)
				this.formValidate.urls=files.substr(0, files.length - 1);  
			},
			setRegion(regionId){
				this.formValidate.regionId=regionId
			},
			handleSubmit(name) {
				let _this=this
				this.$refs[name].validate((valid) => {
					if (valid) {
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/journalism/add',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('新增成功!');
								_this.$refs[name].resetFields();
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		},
		components:{
			Region,Imgs
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/xinwenzixun/add.vue